import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { observer } from 'mobx-react-lite';
import React from 'react';
import './clock.css';


const Clock = ({ header = true, duration, item, onJumpClick = null, hasSearch = false }) => {
    const theme = useTheme();
    const color = header ? theme.palette.warning.main : theme.palette.text.primary

    // Set CSS custom properties for dynamic theming
    React.useEffect(() => {
        document.documentElement.style.setProperty('--primary-color', theme.palette.primary.main);
        document.documentElement.style.setProperty('--primary-color-hover', theme.palette.primary.main + '20');
        document.documentElement.style.setProperty('--warning-color', color);
    }, [theme.palette.primary.main, color]);

    return (
        <div className="clock-container">
            {/* Go Button on the left - only show when there's a search */}
            {onJumpClick && hasSearch && (
                <Tooltip title="Jump to this timestamp" placement="top" arrow>
                    <IconButton
                        onClick={() => onJumpClick(item)}
                        size="small"
                        className="clock-go-button"
                    >
                        <PlayArrowIcon className="clock-go-icon" />
                    </IconButton>
                </Tooltip>
            )}

            {/* Clock display */}
            <div className="clock-display">
                <p className="clock-time">{duration[0]}</p>
                <p className="clock-time-colored">{duration[1]}</p>
            </div>
        </div>
    )
}

export default observer(Clock)